import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';

export class SettingsOptionButton extends Lightning.Component {
  static _template() {
    return {
      rect: true,
      w: w => w,
      h: 116,
      color: Theme.Colors.Transparent,
      Background: {
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 14,
        },
        rect: true,
        x: 0,
        y: 8,
        w: w => w,
        h: h => h - 16,
        color: Theme.Colors.Settings.Background.Normal,
      },
      Label: {
        x: 20,
        y: 20,
        w: w => w - 40,
        h: h => h - 16,
        text: {
          ...Theme.Fonts.Settings.Item,
          advancedRenderer: true,
          textColor: Theme.Colors.Settings.Text,
        },
      },
      Value: {
        x: 20,
        y: 60,
        w: w => w - 40,
        h: h => h - 16,
        text: {
          ...Theme.Fonts.Settings.Item,
          advancedRenderer: true,
          textColor: Theme.Colors.Settings.Text,
        },
      },
    };
  }

  /**
   * @param {SettingsOptionData} data
   */
  set data(data) {
    this._data = data;
    this.tag('Label').text.text = data.label;
    this._updateValue(data.value);
  }

  /**
   * @returns {SettingsOptionData}
   */
  get data() {
    return this._data;
  }

  get label() {
    return this._data.label;
  }

  _focus() {
    this.tag('Background').setSmooth('color', Theme.Colors.Option.Background.Focus);
  }

  _unfocus() {
    this.tag('Background').setSmooth('color', Theme.Colors.Option.Background.Item);
  }

  _handleEnter() {
    this.fireAncestors('$openDialog', {
      type: SelectOptionDialog,
      params: {
        backend: this.backend,
        title: this._data.label,
        options: this._data.options,
        onSuccess: val => {
          this._updateValue(val);
          this.fireAncestors('$closeDialog');
          this.signal('onActivate', this);
        },
        onCancelled: this.hideOptions.bind(this),
      },
    });
  }

  hideOptions() {
    this.fireAncestors('$closeDialog');
  }

  /**
   * @param {OptionData} value
   */
  _updateValue(value) {
    this._data.value = value;
    this.tag('Value').text.text = value ? value.text : '';
  }
}
